import { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@airclou/ui';
import { cn } from '@airclou/ui';
import { useTranslation } from 'react-i18next';

export interface StatCardProps {
  name: string;
  value: string | number;
  icon: LucideIcon;
  change?: string;
  changeType?: 'positive' | 'negative' | 'neutral';
  onClick?: () => void;
}

export function StatCard({ name, value, icon: Icon, change, changeType = 'neutral', onClick }: StatCardProps) {
  const { t } = useTranslation('dashboard');
  return (
    <Card 
      className={cn(
        "relative overflow-hidden transition-all hover:shadow-md",
        onClick && "cursor-pointer"
      )}
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <dt className="truncate text-sm font-medium text-gray-500 dark:text-gray-400 flex items-center gap-2">
              <Icon className="h-4 w-4" />
              {name}
            </dt>
            <dd className="mt-2 text-3xl font-semibold tracking-tight text-foreground">
              {value}
            </dd>
            {change && (
              <div className="mt-2 flex items-baseline text-sm">
                <span
                  className={cn(
                    "font-medium",
                    changeType === 'positive' && 'text-green-600 dark:text-green-400',
                    changeType === 'negative' && 'text-red-600 dark:text-red-400',
                    changeType === 'neutral' && 'text-gray-600 dark:text-gray-400'
                  )}
                >
                  {change}
                </span>
                <span className="ml-1 text-gray-500 dark:text-gray-400">{t('statCard.fromLastMonth')}</span>
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
